























import { Filter } from '@empathy/search-types';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class GoccoFilterHorizontal extends Vue {
  @Prop({ required: true })
  filters: Filter[];

  get childrenFilters(): Filter[] {
    const filter = this.filters.find(f => f.selected);
    return filter ? filter.children : [];
  }
}
